import React from "react";
import { useParams } from "react-router-dom";
import ModalDynamic from "./ModalDynamic";
import ShareModal from "./ShareModal";

export default function ShareModalFunctional() {
  let id = useParams();
  // console.log(id);
  return (
    <div>
      {/* <ModalDynamic matchparams={id} FROM_SHARE_PAGE={true} /> */}
      <ShareModal matchparams={id} />
    </div>
  );
}
